export default function Faq() {
  return (
    <section id="faq" className="py-5 py-5 section-tint">
      <div className="py-4 main-wrap">
        <div className="text-center mb-4">
          <h2 className="h1 fw-semibold mb-2">FAQ</h2>
          <p className="text-secondary mb-0">
            Answers to common questions about therapy with iRise Psychology.
          </p>
        </div>

        <div className="row justify-content-center">
          <div className="col-lg-10 col-xl-9">
            <div className="accordion" id="faqAccordion">
              <div className="accordion-item border-0 shadow-sm rounded-4 overflow-hidden mb-3">
                <h3 className="accordion-header" id="faqHeadingOne">
                  <button
                    className="accordion-button fw-semibold"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#faqCollapseOne"
                    aria-expanded="true"
                    aria-controls="faqCollapseOne"
                  >
                    I am in need of a therapist, why should I choose iRise?
                  </button>
                </h3>
                <div
                  id="faqCollapseOne"
                  className="accordion-collapse collapse show"
                  aria-labelledby="faqHeadingOne"
                  data-bs-parent="#faqAccordion"
                >
                  <div className="accordion-body text-secondary">
                    iRise Psychology offers a professional, compassionate and
                    ethical service of the highest standard. Our psychologists
                    have extensive experience in working with a range of
                    emotional difficulties. This means that they are up to date
                    with the National Institute for Clinical Excellence (NICE)
                    guidelines and offer evidence based treatments.
                    <br />
                    <br />
                    With specialist training in innovative forms of psychological
                    therapy, they are able to offer clients high quality
                    psychological treatments that are both evidence based and
                    tailored to the client’s individual needs.
                  </div>
                </div>
              </div>

              <div className="accordion-item border-0 shadow-sm rounded-4 overflow-hidden mb-3">
                <h3 className="accordion-header" id="faqHeadingTwo">
                  <button
                    className="accordion-button collapsed fw-semibold"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#faqCollapseTwo"
                    aria-expanded="false"
                    aria-controls="faqCollapseTwo"
                  >
                    I have begun looking for a therapist, why do different
                    therapists’ fees vary so much?
                  </button>
                </h3>
                <div
                  id="faqCollapseTwo"
                  className="accordion-collapse collapse"
                  aria-labelledby="faqHeadingTwo"
                  data-bs-parent="#faqAccordion"
                >
                  <div className="accordion-body text-secondary">
                    Therapists’ fees vary a great deal depending on the
                    therapist’s training, qualifications and years of
                    experience.
                    <br />
                    <br />
                    All of our clinical team are Chartered Psychologists which
                    means that they have doctoral level training in a range of
                    psychological therapies and experience with a wide range of
                    presenting difficulties.
                    <br />
                    <br />
                    Training has lasted a minimum of seven years and there is
                    continuous supervision for therapeutic work with experts in
                    order to ensure that the therapy we offer is of the highest
                    standard.
                    <br />
                    <br />
                    Therapists with less training tend to charge less for their
                    services.
                  </div>
                </div>
              </div>

              <div className="accordion-item border-0 shadow-sm rounded-4 overflow-hidden mb-3">
                <h3 className="accordion-header" id="faqHeadingThree">
                  <button
                    className="accordion-button collapsed fw-semibold"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#faqCollapseThree"
                    aria-expanded="false"
                    aria-controls="faqCollapseThree"
                  >
                    Can I refer myself?
                  </button>
                </h3>
                <div
                  id="faqCollapseThree"
                  className="accordion-collapse collapse"
                  aria-labelledby="faqHeadingThree"
                  data-bs-parent="#faqAccordion"
                >
          <div className="accordion-body text-secondary">
  Yes, this can be done by:
  <ul className="mb-0 mt-3">
    <li>
      contacting Dr Benjamin Piper on 07929040880 or e-mailing
      benjamin.piper@irise-psychology.london,
    </li>
    <li>
      contacting Dr René De Barr on 07539447298 or e-mailing
      rene.debarr@irise-psychology.london,
    </li>
    <li>or via our contact us page.</li>
  </ul>
  <div className="mt-3">
    If you are claiming your treatment via your private healthcare provider,
    you may need a referral from a GP or Consultant Psychiatrist. In this case,
    we can give you information about the process entailed.
  </div>
</div>

                </div>
              </div>

              <div className="accordion-item border-0 shadow-sm rounded-4 overflow-hidden mb-3">
                <h3 className="accordion-header" id="faqHeadingFour">
                  <button
                    className="accordion-button collapsed fw-semibold"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#faqCollapseFour"
                    aria-expanded="false"
                    aria-controls="faqCollapseFour"
                  >
                    Is it confidential?
                  </button>
                </h3>
                <div
                  id="faqCollapseFour"
                  className="accordion-collapse collapse"
                  aria-labelledby="faqHeadingFour"
                  data-bs-parent="#faqAccordion"
                >
                  <div className="accordion-body text-secondary">
                    Chartered Psychologists must adhere to clear and strict
                    guidelines on confidentiality.
                    <br />
                    <br />
                    The content of any client notes kept remain private and
                    confidential.
                    <br />
                    <br />
                    If there are circumstances where this may not apply, it will
                    be discussed during your first appointment.
                  </div>
                </div>
              </div>

              <div className="accordion-item border-0 shadow-sm rounded-4 overflow-hidden mb-3">
                <h3 className="accordion-header" id="faqHeadingFive">
                  <button
                    className="accordion-button collapsed fw-semibold"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#faqCollapseFive"
                    aria-expanded="false"
                    aria-controls="faqCollapseFive"
                  >
                    Do I have to inform my GP?
                  </button>
                </h3>
                <div
                  id="faqCollapseFive"
                  className="accordion-collapse collapse"
                  aria-labelledby="faqHeadingFive"
                  data-bs-parent="#faqAccordion"
                >
                  <div className="accordion-body text-secondary">
                    No, however, for ethical and professional reasons it may be
                    appropriate for severe mental illness to ask for your GP’s
                    details in case we need to contact them.
                  </div>
                </div>
              </div>

              <div className="accordion-item border-0 shadow-sm rounded-4 overflow-hidden mb-3">
                <h3 className="accordion-header" id="faqHeadingSix">
                  <button
                    className="accordion-button collapsed fw-semibold"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#faqCollapseSix"
                    aria-expanded="false"
                    aria-controls="faqCollapseSix"
                  >
                    What happens in the initial appointment?
                  </button>
                </h3>
                <div
                  id="faqCollapseSix"
                  className="accordion-collapse collapse"
                  aria-labelledby="faqHeadingSix"
                  data-bs-parent="#faqAccordion"
                >
                  <div className="accordion-body text-secondary">
                    Your initial consultation is a 50 minute assessment and is
                    an opportunity to discuss your current issues and for us to
                    consider together how psychological therapy would be of help
                    to you.
                    <br />
                    <br />
                    During the assessment, the psychologist will facilitate a
                    discussion of the reasons that led you to seek psychological
                    therapy but will also take a detailed family history in
                    order to understand you in the context of your past and your
                    life experiences.
                    <br />
                    <br />
                    Towards the end of the assessment, the psychologist will
                    indicate to you different ways you could work together and
                    propose a therapeutic plan.
                    <br />
                    <br />
                    You can then make a decision at the time to attend for a
                    number of sessions or you can go away and think about it and
                    arrange another appointment subsequently.
                  </div>
                </div>
              </div>

              <div className="accordion-item border-0 shadow-sm rounded-4 overflow-hidden mb-3">
                <h3 className="accordion-header" id="faqHeadingSeven">
                  <button
                    className="accordion-button collapsed fw-semibold"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#faqCollapseSeven"
                    aria-expanded="false"
                    aria-controls="faqCollapseSeven"
                  >
                    How long will I be in therapy for?
                  </button>
                </h3>
                <div
                  id="faqCollapseSeven"
                  className="accordion-collapse collapse"
                  aria-labelledby="faqHeadingSeven"
                  data-bs-parent="#faqAccordion"
                >
                  <div className="accordion-body text-secondary">
                    The duration of therapy varies greatly depending on the
                    client’s presenting difficulties and their personal goals.
                    <br />
                    <br />
                    Some individuals choose to attend therapy for a very
                    specific concern and often it is possible to work in a
                    focused and short term way with them.
                    <br />
                    <br />
                    In other instances, difficulties are deeply rooted and might
                    require long term therapy.
                    <br />
                    <br />
                    During the assessment, your psychologist will give you an
                    indication of the proposed duration of therapy on the basis
                    of their understanding of your difficulties. The therapeutic
                    contract is always agreed jointly between client and
                    therapist and so attending the first session does not commit
                    you to attending any ongoing sessions. This is why attending
                    an assessment session is useful if you are not sure you need
                    therapy.
                  </div>
                </div>
              </div>

              <div className="accordion-item border-0 shadow-sm rounded-4 overflow-hidden">
                <h3 className="accordion-header" id="faqHeadingEight">
                  <button
                    className="accordion-button collapsed fw-semibold"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#faqCollapseEight"
                    aria-expanded="false"
                    aria-controls="faqCollapseEight"
                  >
                    Do I have to have a diagnosis or specific problem to use
                    your service?
                  </button>
                </h3>
                <div
                  id="faqCollapseEight"
                  className="accordion-collapse collapse"
                  aria-labelledby="faqHeadingEight"
                  data-bs-parent="#faqAccordion"
                >
                  <div className="accordion-body text-secondary">
                    No, very often people come to therapy to make changes in
                    various areas of their life, such as work or relationships.
                    Notwithstanding this, you and your therapist will usually
                    set specific aims to achieve whilst in therapy.
                  </div>
                </div>
              </div>
            </div>

            <div className="text-center mt-4">
              <a className="btn btn-outline-brand fw-semibold" href="#contact">
                Contact Us
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
